import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import * as components from 'vuetify/lib/components';
import {TiptapVuetifyPlugin} from 'tiptap-vuetify/dist/bundle-umd';

import variables from '@/helpers/variables';
import {
  VAutocompleteWithMatchedMenu,
  VSelectWithMatchedMenu,
} from '@/plugins/vuetify-select-menu-width';

const vuetify = new Vuetify(variables.vuetifySettings);

window.vuetify = vuetify;

Vue.use(Vuetify, {
  components: {
    ...components,
    VAutocomplete: VAutocompleteWithMatchedMenu,
    VSelect: VSelectWithMatchedMenu,
  },
});
Vue.use(TiptapVuetifyPlugin, {vuetify});

export default vuetify;
